import { push } from '@lagunovsky/redux-react-router'
import { PATH_NAME } from 'app/constants'
import { all, put, takeLatest } from 'redux-saga/effects'
import { REDIRECT_TO_ERROR_PAGE, setErrorMessage } from './reducer'

function* redirectSaga({ action, payload }) {
    if (REDIRECT_TO_ERROR_PAGE.includes(payload)) {
        yield put(push(PATH_NAME.ERROR))
    }
}

export default function* messagesListSaga() {
    yield all([takeLatest(setErrorMessage.type, redirectSaga)])
}
